<pageheader [entity]="headerEntity"></pageheader>
<div *ngIf="listView" class="top-btns">
  <div class="table-outer">
    <grid [entities]="entities" [actionExclude]="['feedback','column']" [checkboxCol]="true" [entityColumns]="Columns"
      [selectionField]="'App_Mode_Id'" [addEntityIcon]="'bi bi-plus-square'" [addEntityCaption]="'Add'"
      [downloadEntityCaption]="'Download '" (downloadEntities)="onExcelExport()" (addEntity)="addMode($event)"
      (editEntity)="editMode($event)" (refreshEntities)="refresh($event)" (deleteEntity)="delete($event)"
      (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
      [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>
  </div>
</div>

<div *ngIf="!listView">
  <div class="report top-btns">
    <div class="form-caption-nav">
      {{ formCaption }}
    </div>
    <nav class="navbar-expand-md navbar-white navbar-form bg-light mt-2">
      <ul class="navbar-nav justify-content-end">
        <li class="nav-item">
          <a class="nav-link" (click)="clear()"><i class="bi bi-slash-circle"></i>Clear</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="revertChanges()"><i class="bi bi-arrow-clockwise"></i>Revert
            Changes</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="gotoBack()"><i class="bi bi-arrow-left-circle"></i>Go Back</a>
        </li>
      </ul>
    </nav>
    <div class="form-body">
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <textbox [caption]="'Expense Head'" [formData]="entity" [maxlength]="100" [mandatory]="true"
              (paste)="onPaste($event)" onCopy="return false" [fieldName]="'ExpenseHeadName'"
              [(ngModel)]="entity.ExpenseHeadName" ngDefaultControl></textbox>

          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <dropdown [caption]="'Parent Expense Head'" [formData]="entity" [data]="parentExpenseHeads"
              [filterable]="true" (filterChanged)="getAllParentExpenseHeads($event)"
              [(ngModel)]="entity.Parent_ExpenseHead_Id" [textField]="'ExpenseHeadName'" [valueField]="'ExpenseHead_Id'"
              [fieldName]="'Parent_ExpenseHead_Id'" [selectedItem]="selectedParentExpHead" ngDefaultControl>
            </dropdown>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <dropdown [caption]="'Company'" [formData]="entity" [data]="company" [mandatory]="true" [filterable]="true"
              (filterChanged)="getAllCompany($event)" [(ngModel)]="entity.Company_Id" [textField]="'CompanyName'"
              [valueField]="'Company_Id'" [fieldName]="'Company_Id'" [selectedItem]="selectedCompany" ngDefaultControl>
            </dropdown>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <dropdown [caption]="'Division'" [formData]="entity" [data]="divisions" [mandatory]="true"
              [filterable]="true" (filterChanged)="getAllDivisions($event)" [(ngModel)]="entity.Division_Id"
              [textField]="'DivisionName'" [valueField]="'Division_Id'" [fieldName]="'Division_Id'"
              [selectedItem]="selectedDivision" ngDefaultControl>
            </dropdown>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <dropdown [caption]="'Location'" [formData]="entity" [data]="locations" [mandatory]="true"
              [filterable]="true" (filterChanged)="getAllLocations($event)" [(ngModel)]="entity.Location_Id"
              [textField]="'LocationName'" [valueField]="'Location_Id'" [fieldName]="'Location_Id'"
              [selectedItem]="selectedLocation" ngDefaultControl>
            </dropdown>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-3">
            <dropdown [caption]="'Department'" [formData]="entity" [data]="departments" [mandatory]="true"
              [filterable]="true" (filterChanged)="getAllDepartments($event)" [(ngModel)]="entity.Department_Id"
              [textField]="'DepartmentName'" [valueField]="'Department_Id'" [fieldName]="'Department_Id'"
              [selectedItem]="selectedDepartment" ngDefaultControl>
            </dropdown>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
              <div class="mb-3">
                  <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
              </div>
          </div>
      </div>
      </div>
      <div class="mt-3">
        <btn [label]="'Save'" (click)="save($event)" [class]="'btn btn-primary float-start me-2'"
          [disabled]="saveDisabled" [type]="'button'">
        </btn>
      </div>
    </div>
  </div>
</div>


<kendo-excelexport [data]="entities.data" [collapsible]="true" fileName="ExpenseHead.xlsx" #excelexport>
  <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="ExpenseHeadName" title="Expense Head" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="ParentExpenseHeadName" title="Parent Expense Head" [width]="200">
  </kendo-excelexport-column>
</kendo-excelexport>